// src/js/slider.js

export function initSlider() {
  const track = document.querySelector('.slider-track');
  const prevBtn = document.querySelector('.prev-btn');
  const nextBtn = document.querySelector('.next-btn');

  const cards = document.querySelectorAll('.product-card');
  if (!cards.length) return;

  let currentIndex = 0;
  const cardWidth = cards[0].offsetWidth + 20;
  const totalCards = cards.length;
  const visibleCards = Math.floor(
    document.querySelector('.slider-container').offsetWidth / cardWidth
  );

  function updateSlider() {
    track.style.transform = `translateX(-${currentIndex * cardWidth}px)`;
  }

  nextBtn.addEventListener('click', () => {
    if (currentIndex < totalCards - visibleCards) {
      currentIndex++;
      updateSlider();
    }
  });

  prevBtn.addEventListener('click', () => {
    if (currentIndex > 0) {
      currentIndex--;
      updateSlider();
    }
  });

  setInterval(() => {
    currentIndex =
      currentIndex < totalCards - visibleCards ? currentIndex + 1 : 0;
    updateSlider();
  }, 5000);
}
